class NsGalleryMenu extends HTMLElement {
  connectedCallback() {
    if(this.abort) return;
    this.abort=new AbortController();
    const opts={signal:this.abort.signal};
    this.details=this.querySelector('details');
    this.trigger=this.querySelector('summary');
    this.panel=this.querySelector('.ns-nav-gallery');
    this.veil=this.querySelector('.ns-nav-veil');
    if(!this.details || !this.trigger || !this.panel) return;
    this.setPosition=()=>{
      const bottom=Math.max(0,document.querySelector('#header-component')?.getBoundingClientRect().bottom||96)+'px';
      this.style.setProperty('--ns-nav-bottom',bottom);
      document.querySelector('#Drawer-Menu')?.style.setProperty('--ns-nav-bottom',bottom);
    };
    this.close=()=>{clearTimeout(this.timer);this.details.open=false;};
    this.details.addEventListener('toggle',()=>{
      this.trigger.setAttribute('aria-expanded',String(this.details.open));
      if(this.details.open){
        this.setPosition();
        document.querySelectorAll('ns-gallery-menu').forEach(menu=>{if(menu!==this) menu.close?.();});
        document.querySelectorAll('[data-mega-menu-item]').forEach(menu=>menu.close?.());
      }
    },opts);
    this.trigger.addEventListener('click',event=>{
      if(event.pointerType==='mouse' && matchMedia('(min-width:1025px)').matches){
        event.preventDefault();clearTimeout(this.timer);this.setPosition();this.details.open=true;
      }
    },opts);
    this.trigger.addEventListener('pointerenter',event=>{
      if(event.pointerType==='mouse' && matchMedia('(min-width:1025px)').matches){clearTimeout(this.timer);this.setPosition();this.details.open=true;}
    },opts);
    const leave=event=>{
      if(event.pointerType==='mouse') this.timer=setTimeout(()=>{if(!this.trigger.matches(':hover') && !this.panel.matches(':hover') && !this.contains(document.activeElement)) this.close();},200);
    };
    this.trigger.addEventListener('pointerleave',leave,opts);
    this.panel.addEventListener('pointerleave',leave,opts);
    this.panel.addEventListener('pointerenter',()=>clearTimeout(this.timer),opts);
    this.addEventListener('focusout',()=>setTimeout(()=>{if(this.isConnected && !this.contains(document.activeElement)) this.close();},0),opts);
    this.trigger.addEventListener('keydown',event=>{
      if(event.key==='ArrowDown'){event.preventDefault();this.setPosition();this.details.open=true;this.panel.querySelector('a')?.focus();}
    },opts);
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape' && this.details.open){event.preventDefault();this.close();this.trigger.focus();}
    },opts);
    document.addEventListener('click',event=>{
      if(event.target.closest('side-drawer-opener[data-side-drawer="#Drawer-Menu"]')) this.setPosition();
      if(this.details.open && (!this.contains(event.target) || event.target===this.veil)) this.close();
    },opts);
    window.addEventListener('resize',()=>{this.setPosition();if(innerWidth<=1024)this.close();},opts);
    window.addEventListener('scroll',this.setPosition,{...opts,passive:true});
    this.addEventListener('shopify:block:select',()=>{this.setPosition();this.details.open=true;},opts);
    this.addEventListener('shopify:block:deselect',this.close,opts);
  }
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.abort=null;}
}
if(!customElements.get('ns-gallery-menu')) customElements.define('ns-gallery-menu',NsGalleryMenu);
